import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useReducer,
} from 'react'

import { Dispatch, Props, State } from './types'
import reducer from './reducer'

const initialState: State = {
  isOpen: false,
  hotelId: null,
}

const initialValue: Props = {
  dispatchs: {
    open: () => null,
    close: () => null,
  },
  provided: false,
  state: initialState,
}

export const LetterOfConsentContext = createContext<Props>(initialValue)

export const LetterOfConsentProvider: React.FunctionComponent = ({
  children,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const open = useCallback((hotelId: number) => {
    dispatch({
      type: 'OPEN_LETTER_OF_CONSENT',
      payload: { hotelId },
    })
  }, [])

  const close = useCallback(() => {
    dispatch({
      type: 'CLOSE_LETTER_OF_CONSENT',
    })
  }, [])

  const dispatchs = useMemo(
    () => ({
      open,
      close,
    }),
    [open, close]
  )

  return (
    <LetterOfConsentContext.Provider
      value={{
        dispatchs,
        provided: true,
        state,
      }}
    >
      {children}
    </LetterOfConsentContext.Provider>
  )
}

export const useLetterOfConsent = (): [Dispatch, State] => {
  const { state, provided, dispatchs } = useContext(LetterOfConsentContext)

  if (!provided) {
    throw new Error(
      'useLetterOfConsent must be used within a LetterOfConsentProvider.'
    )
  }

  return [dispatchs, state]
}
